<script setup>
import { Loading } from 'vant';
import { useStore } from "vuex";
import KeyboardPlugin from '@/components/SimpleKeyboard';
import { onMounted ,computed, getCurrentInstance,ref } from 'vue';
const page = getCurrentInstance()
// const store = useStore();
// const loading = computed(() => {
//   return store.state.loading
// });
onMounted(()=>{
  // let resizeTimer;
  // window.addEventListener('resize', () => {
  //   clearTimeout(resizeTimer);
  //   resizeTimer = setTimeout(() => adjustLayout(), 300);
  // });
})

const text = ref('')
const showKeyboard= ref(true) 
const onInputChange = (value) =>{
  console.log(value)
}
const onKeyPress = (button) =>{
  if (button === '{close}') {
    this.showKeyboard = false;
  }
}
onMounted(()=>{
})
</script>

<template>
<div>
  <!-- <KeyboardPlugin v-model="showKeyboard" :input="text"  @change="onInputChange"/> -->
  <router-view></router-view>
</div>
</template>

<style lang="less">
#app {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  .gloading {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 30;

    .van-loading__spinner {
      width: 100px;
      height: 100px;
    }
  }
}
.hg-theme-default .hg-row:not(:last-child) {
    margin-bottom: 25px !important;
  }
  .hg-row{
    div{
      min-height: 100px;
    }
  }
@media only screen and (min-device-width: 750px) and (max-device-width: 1119px) {
  .hg-theme-default .hg-row:not(:last-child) {
    margin-bottom: 15px !important;
  }
  .hg-row{
    div{
      min-height: 70px;
      font-size: 22px;
    }
  }
}
.van-popup--round{
  box-shadow: 0 4px 8px rgba(0, 0, 0, 1);
}
</style>